import { Button, Col, Row } from 'antd';
import React from 'react';
import ByMuvu from '../../PatientLandingGeneralComponents/ByMuvu';
import healthSurveyTexts from '../../utils/healthSurveyTexts.json';

const HealthSurveyDisclaimer = ({ getSurveyData }) => {
  return (
    <Row className='patient-landing-container mt-30 mr-30 ml-30' justify="center">
      <Col lg={24} span={24} md={24}>
        <h2 className="mb-0 text-center"><strong>¡Importante!</strong></h2>
      </Col>
      <Col span={24} xs={24} sm={20} lg={12} md={12} xl={6}>
        <div className='disclaimer-container mt-20'>
          <p className='text-center'>
            {healthSurveyTexts.disclaimerText}
          </p>
        </div>
      </Col>
      <Col span={24} className="mt-50">
        <Row justify="center">
          <Col span={24} xs={12} sm={6} lg={4} md={6} xl={4}>
            <Button className="cmt-button primary" type="primary" onClick={getSurveyData.setOccupied} size="large" loading={getSurveyData.loading}>
              Comenzar
            </Button>
          </Col>
        </Row>
        <Row justify="center mt-20">
          <Col span={24} xs={12} sm={6} lg={4} md={6} xl={4}>
            <Button
              className="cmt-button primary outline"
              type="primary"
              onClick={getSurveyData.goBack}
            >
              Volver
            </Button>
          </Col>
          <Col span={24} className='mt-30'>
            <ByMuvu />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default HealthSurveyDisclaimer;
